export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/frameScheduler.worker.d1f7b1ad.worker.js");
}
